var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 879.125 631.485",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shopping illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M.275.365H645v412.91H.275z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.711 52.154h607.853v336.693H18.711z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#397ccc",
    d: "M0 0h644.725v27.39H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.355,
    cy: 14.004,
    r: 5.077,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.624,
    cy: 14.004,
    r: 5.077,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.893,
    cy: 14.004,
    r: 5.077,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M93.5 79.848h118.887V208.83H93.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M263.193 79.848H382.08V208.83H263.193z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M432.885 79.848h118.887V208.83H432.885z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M93.5 232.176h118.887v128.982H93.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M263.193 232.176H382.08v128.982H263.193z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M432.885 232.176h118.887v128.982H432.885z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m291.928 265.325 21.722-8.588 2.526 42.939s4.546 13.134 3.031 18.186c0 0 1.01 8.588-1.516 9.093s-9.6 1.516-10.1 1.01-.505-2.021-.505-2.021-5.052 3.536-5.557 7.577c0 0-21.217 6.567-21.722.505s10.608-11.114 10.608-11.114l8.588-13.134Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m337.9 265.325 21.719-8.588 2.526 42.939s4.546 13.134 3.031 18.186c0 0 1.01 8.588-1.516 9.093s-9.6 1.516-10.1 1.01-.505-2.021-.505-2.021-5.052 3.536-5.557 7.577c0 0-21.217 6.567-21.722.505s10.608-11.114 10.608-11.114l8.588-13.134Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M340.022 99.51s-4.625 12.924.734 18.752l-4.468 15.353s15.874 47.622 11.339 54.274c0 0-16.932 8.466-50.8-3.024l13.757-53.367-1.965-22.526 2.721-10.583 6.047-.6s-3.628 13.606 3.024 15.723 13.141-15.383 13.141-15.383Z",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m126.421 182.937 5.837 2.388 27.858-36.613 8.755 42.98 5.837-1.061c3.744-37.055 6.8-74.85 3.051-92.726l-21.623-.929-9.816 31.311-4.776 21.225Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M480.678 97.612s-7.966 11.074-7.577 15.543 5.44 77.327 5.44 77.327l11.852.583-3.5-52.458 2.914-14.183 7.189 66.058 14.572.389-13.017-85.681-2.526-7.577Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M525.7 276.018c-2.115-2.538-5.751-3.91-9.242-4.652.1-.317-10.618-2.532-10.8-2.076l-4.041-3.219-12.417 6.447-6.977-4.75-3.241 1.15c.132-.572-10.061 1.194-10.061 1.194-1.947.07-4.434.192-7.218.406-9.749.75-10.5 26-10.5 26a39.85 39.85 0 0 1 14.113-2.955l2.635 30.2c13.553-1.162 27.767.19 42.5 3.5l6.909-23.74 16.089-6.257s-2.749-15.249-7.749-21.248Z",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M180.441 261.637c-1.743-2.091-4.738-3.222-7.615-3.833.086-.262-8.749-2.086-8.9-1.71l-3.33-2.652-10.229 5.312-5.749-3.913-2.67.948c.109-.471-8.29.983-8.29.983-1.6.058-3.654.158-5.947.335-8.033.618-8.651 21.421-8.651 21.421a32.837 32.837 0 0 1 11.629-2.435l2.171 60.914c11.167-.958 22.879.157 35.015 2.884l5.692-55.59 13.257-5.155s-2.264-12.564-6.383-17.509Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M749.45 277.851h57v-30.5a28.5 28.5 0 1 0-57 0Z",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M724.005 617.195h-12.259l-5.833-47.292h18.094Z",
    fill: "#ffb6b6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M727.132 613.192h-24.145a15.387 15.387 0 0 0-15.386 15.385v.5h39.531Z",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m870.559 600.834-10.676 6.027-28.328-38.311 15.757-8.895Z",
    fill: "#ffb6b6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m871.314 595.811-21.025 11.866a15.387 15.387 0 0 0-5.834 20.963l.246.435 34.424-19.433Z",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m792.205 404.524.946 4.73s2.838 2.838 1.419 4.257-.946 8.042-.946 8.042c.794 12.076 16.573 79.936 19.395 93.189 0 0 21.76 14.191 38.789 42.1s17.5 35.005 17.5 35.005l-18.918 8.043-47.3-57.238s-13.245-8.042-17.976-15.137-34.064-80.418-34.064-80.418l-16.56 76.633s.946 27.909-3.311 45.885a192.522 192.522 0 0 0-4.73 34.532l-22.233-2.365s1.419-67.172 3.784-74.268c0 0-9.934-81.836 9.934-114.476l16.012-42.687 15.682-6.036Z",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M778.244 226.307c-29.847.51-29.842 44.907 0 45.412 29.845-.51 29.841-44.907 0-45.412Z",
    fill: "#ffb8b8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M755.273 247.835h5.073l1.381-3.454-.691 3.454h27.745l-.9-7.227 6.744 7.227h6.727v-3.916a23.038 23.038 0 1 0-46.076-.033v.033Z",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m747.466 284.977 56.4.457-11.916 120.917s-65.959-3.481-66-23.614l6.179-17.891Z",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M806.29 418.04a9.377 9.377 0 0 1 2.7-14.122l-2.451-21.287 12.573-4.645 3.039 30.111a9.428 9.428 0 0 1-15.861 9.943Z",
    fill: "#ffb6b6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m796.45 295.851 7.421-10.373s5.079-1.127 11.079 5.873 9.5 94.5 9.5 94.5l-22 5-13-62Z",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m672.135 390.739 1.636 77.737 50.325 26.595 91.648-16.366 2.251-80.806-58.099-20.458-87.761 13.298z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m723.965 495.91-50.987-26.944-1.662-78.916 88.658-13.433.19.066 58.65 20.652-2.284 82.046Zm-49.4-27.924 49.662 26.245 90.732-16.202 2.216-79.567-57.356-20.196-86.866 13.161Z",
    fill: "#cacaca"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "m722.973 411.816-.197-.078-50.938-20.253.593-1.493 50.742 20.174 94.712-13.063.22 1.592-95.132 13.121z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "m722.27 411.001 1.606-.02 1.023 84.08-1.607.02zM716.536 407.792l-18.362-7.444 88.395-14.085 18.362 7.443-88.395 14.086zM671.817 414.765l.636-1.476 21.296 9.17-.636 1.475z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#397ccc",
    d: "m681.46 441.286.636-1.476 21.296 9.17-.636 1.475z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m392.135 498.739 1.636 77.737 50.325 26.595 91.648-16.366 2.251-80.806-58.099-20.458-87.761 13.298z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m443.965 603.91-50.987-26.944-1.662-78.916 88.658-13.433.19.066 58.65 20.652-2.284 82.046Zm-49.4-27.924 49.662 26.245 90.732-16.202 2.216-79.567-57.356-20.196-86.866 13.161Z",
    fill: "#cacaca"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "m442.973 519.816-.197-.078-50.938-20.253.593-1.493 50.742 20.174 94.712-13.063.22 1.592-95.132 13.121z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#cacaca",
    d: "m442.27 519.001 1.606-.02 1.023 84.08-1.607.02zM432.088 513.962l-13.914-5.614 88.395-14.085 13.913 5.614-88.394 14.085zM391.817 522.765l.636-1.476 21.296 9.17-.636 1.475z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#397ccc",
    d: "m401.46 549.286.636-1.476 21.296 9.17-.636 1.475zM479.563 509.397l1.9 90.241 58.419 30.872 106.389-18.998 2.612-93.803-67.443-23.748-101.877 15.436z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m539.73 631.485-59.189-31.279-1.928-91.608 102.917-15.594.22.077 68.085 23.974-2.653 95.241Zm-57.346-32.416 57.65 30.466 105.325-18.808 2.572-92.364-66.581-23.445-100.837 15.279Z",
    fill: "#3f3d56"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m538.578 533.865-.228-.091-59.132-23.51.689-1.734 58.903 23.419 109.945-15.164.255 1.848-110.432 15.232z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m537.761 532.918 1.866-.023 1.187 97.603-1.866.023zM526.888 527.112l-17.098-6.559 102.612-16.351 17.099 6.559-102.613 16.351zM479.194 537.289l.738-1.714 24.722 10.644-.738 1.714z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m490.388 568.074.738-1.714 24.722 10.644-.738 1.714z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M700.668 403.593a9.377 9.377 0 0 0 3.673-13.9l11.422-18.13-9.324-9.628-15.771 25.829a9.428 9.428 0 0 0 10 15.83Z",
    fill: "#ffb6b6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m756.133 289.743-8.183-5.392s-6.315 1.416-13.031 14.334-33.8 70.672-33.8 70.672l11.133 11.3 29.7-45.309Z",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.9671b00deb1a1bbb465e4436314df53b.svg";
export { ForwardRef as ReactComponent };